import { ImportTableDescriptorType } from '../../types';

type DescriptorUpdateSpecType = Pick<
    ImportTableDescriptorType,
    'inputScale' | 'label' | 'dataType' | 'verticalCalculation'
> & { descriptorId: ImportTableDescriptorType['id'] };

export function getDescriptorsUpdateSpec(descriptors: ImportTableDescriptorType[]): DescriptorUpdateSpecType[] {
    return descriptors.map((x) => ({
        descriptorId: x.id,
        inputScale: x.inputScale,
        label: x.label,
        dataType: x.dataType,
        verticalCalculation: x.verticalCalculation,
    }));
}
